import React from 'react';
import SchedulerCalendar from '../../../components/calendar/SchedulerCalendar';
const SUR_ID = '7c031bfe-8453-4b2f-9497-e2fa81459065';

export default function ViewTerpelSur() {
  return (
    <div className="operation-view terpel-sur-view">
      <SchedulerCalendar operationId={SUR_ID} />
    </div>
  );
}